// This file is used as a shim of "BlobDownloadResponse" for some browser bundlers
// when trying to bundle "BlobDownloadResponse"
// "BlobDownloadResponse" class is only available in Node.js runtime
export var BlobDownloadResponse = 1;
//# sourceMappingURL=BlobDownloadResponse.browser.js.map